import { themeColors } from '@hg/stylizator/utils'

const theme = {
  name: 'web',
  color: themeColors,
}

export type ITheme = typeof theme

export default theme
